import authReducer from './reducers';
import * as authOperations from './operations';
import * as authTypes from './types';

export { authOperations, authTypes };
export default authReducer;
